import type { RouteRecordRaw } from 'vue-router'

const platformRoutes: RouteRecordRaw[] = [
  {
    path: '/platform',
    name: 'Platform',
    meta: { 
      requiresAuth: true,
      requiredPermissions: ['platform:view'],
      title: '平台管理'
    },
    children: [
      {
        path: 'modules',
        name: 'PlatformModules',
        component: () => import('@/views/platform/modules/ModuleList.vue'),
        meta: {
          requiresAuth: true,
          requiredPermissions: ['platform:module:view'],
          title: '模块管理'
        },
      },
      {
        path: 'merchants',
        name: 'PlatformMerchants',
        component: () => import('@/views/platform/merchants/MerchantList.vue'),
        meta: { 
          requiresAuth: true,
          requiredPermissions: ['platform:merchant:view'],
          title: '组织管理'
        },
      },
      {
        path: 'users',
        name: 'PlatformUsers',
        component: () => import('@/views/platform/users/UserList.vue'),
        meta: { 
          requiresAuth: true,
          requiredPermissions: ['platform:user:view'],
          title: '用户管理'
        },
      }
    ],
  },
]

export default platformRoutes
